import { createContext, ReactNode } from 'react';
import { useImmerReducer } from 'use-immer';

import {
  ISearchTermDispatch,
  ISearchTermState,
  searchTermReducer,
} from 'search/state/SearchTermReducer';

export const SearchTermStateContext = createContext<ISearchTermState>(null);
export const SearchTermDispatchContext = createContext<ISearchTermDispatch>(null);

interface ISearchTermProvider {
  children: ReactNode;
}

export const SearchTermProvider = ({ children }: ISearchTermProvider) => {
  const initialValues = {
    currentSearchTerm: 'TERM_UNKNOWN',
  };
  const [state, dispatch] = useImmerReducer(searchTermReducer, initialValues);

  return (
    <SearchTermDispatchContext.Provider value={dispatch}>
      <SearchTermStateContext.Provider value={state}>{children}</SearchTermStateContext.Provider>
    </SearchTermDispatchContext.Provider>
  );
};
